import emptyStateImage from '@assets/images/empty-state.svg';
import { Button } from '@components/ui/button';
import { cn } from '@lib/utils';
import { TileHeader, TileHeaderProps } from './tile-header.component';

export type EmptyStateContainerProps = {
  action?: React.ReactNode;
  className?: string;
  header?: TileHeaderProps;
  message?: React.ReactNode;
  onClick?: () => void;
  title?: string;
};

export const EmptyStateContainer: React.FC<EmptyStateContainerProps> = (props) => {
  const { action, className, header, message, onClick, title } = props;

  return (
    <div className={cn('flex flex-col flex-1 gap-2 justify-center items-center', className)}>
      {header && <TileHeader {...header} />}
      <div className="flex justify-center">
        <img src={emptyStateImage} />
      </div>
      {(message || title || action) && (
        <div className="flex flex-col gap-2 justify-center text-center p-4">
          {title && <div className="text-base font-medium">{title}</div>}
          {action && action}
          {message && (
            <>
              {onClick ? (
                <Button
                  className="text-sm text-center"
                  onClick={onClick}
                  variant="link"
                >
                  {message}
                </Button>
              ) : (
                <div className="text-sm text-center text-[#1F1C1A99]">{message}</div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};
